<template>
  <svg
    version="1.1"
    :id="iconName"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 14 15"
    style="enable-background:new 0 0 14 15;"
    :class="iconName"
    xml:space="preserve"
    :width="width"
    :height="height"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <g>
      <path d="M7 0.96875C3.25391 0.96875 0.21875 4.00391 0.21875 7.75C0.21875 11.4961 3.25391 14.5312 7 14.5312C10.7461 14.5312 13.7812 11.4961 13.7812 7.75C13.7812 4.00391 10.7461 0.96875 7 0.96875ZM7 13.2188C3.96484 13.2188 1.53125 10.7852 1.53125 7.75C1.53125 4.74219 3.96484 2.28125 7 2.28125C10.0078 2.28125 12.4688 4.74219 12.4688 7.75C12.4688 10.7852 10.0078 13.2188 7 13.2188ZM9.76172 6.05469C9.89844 5.94531 9.89844 5.72656 9.76172 5.58984L9.16016 4.98828C9.02344 4.85156 8.80469 4.85156 8.69531 4.98828L7 6.68359L5.27734 4.98828C5.16797 4.85156 4.94922 4.85156 4.8125 4.98828L4.21094 5.58984C4.07422 5.72656 4.07422 5.94531 4.21094 6.05469L5.90625 7.75L4.21094 9.47266C4.07422 9.58203 4.07422 9.80078 4.21094 9.9375L4.8125 10.5391C4.94922 10.6758 5.16797 10.6758 5.27734 10.5391L7 8.84375L8.69531 10.5391C8.80469 10.6758 9.02344 10.6758 9.16016 10.5391L9.76172 9.9375C9.89844 9.80078 9.89844 9.58203 9.76172 9.47266L8.06641 7.75L9.76172 6.05469Z"/>
    </g>
  </svg>
</template>
<style scoped>
.icon-circle-error {
  fill: currentColor;
  height: 24px;
  width: 24px;
  border-radius: initial;
}
</style>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "icon-circle-error"
    },
    width: {
      type: [Number, String],
      default: 12
    },
    height: {
      type: [Number, String],
      default: 12
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>